export const SELECT_TRANSMISION = "SELECT_TRANSMISION";
export const SELECT_VEHICULO = "SELECT_VEHICULO";
export const RESET = "RESET";

export const selectVehiculo = vehiculo => ({
    type: SELECT_VEHICULO,
    vehiculo
})

export const reset = () => ({
    type: RESET
})